<template>
	<div>
		<div class="bodywraplist">
			<div class="topTit">团购列表</div>
			<mt-loadmore :bottom-method="grouplist" ref="loadmore" :bottom-all-loaded="allLoaded">
				<div class="grouplist" v-for="(item,index) in groupList">
					<a :href="'/mapply/groupbuy/index?groupId='+item.id">
						<div class="grouplist-tit">{{item.groupName}}</div>
						<div class="whitewrap">
							<div class="grouplist-time">
								活动时间:
								<span>{{item.beginTime?$moment(item.beginTime).format("YYYY-MM-DD HH:mm:ss"):''}}</span>-
								<span>{{item.endTime?$moment(item.endTime).format("YYYY-MM-DD HH:mm:ss"):''}}</span>
							</div>
							<div class="grouplist-add">
								活动地点:
								<span>{{item.address}}</span>
							</div>
						</div>
					</a>
				 </div>
				
			</mt-loadmore>
		</div>
	</div>
</template>
<style type="text/css" lang="less" scoped>
</style>
<script type="text/javascript">
	import { Loadmore } from 'mint-ui'
	export default {
		name: 'grouplist',
		data() {
			return {
				pageNum:0,
				pageSize: 10,
				groupList: [],
				allLoaded: false //是否可以上拉属性

			}
		},
		beforeCreate: function() {
			document.title = "团购列表";
			getCommonJsIns.initSingleCSSNEW({
				cssURL: "/css/mapply/groupbuy/grouplist.css"
			});
		},
		mounted: function() {
			var self = this;
			//确保重要依赖的js加载完成
			getCommonJsIns.initJSNEW(this.webReady);
		},
		methods: {
			webReady: function() {
				var self = this;
				self.grouplist();
			},
			grouplist: function() {
				var self = this;
				self.pageNum = self.pageNum + 1;
				self.ajaxSubmit.ajax({
					url: self.commmonWebConfig.tuancheapi + self.ajaxSubmit.allUrl.grouplistPage,
					type: "get",
					data: {
						cityId: self.$route.query.cityId,
						modelId: self.$route.query.modelId,
						isCurrent: 1,
						isNotExactly: 1,
						pageNum: self.pageNum,
						pageSize: self.pageSize
					},
					success: function(data) {
						if(data.responseHeader.status == 200) {
							console.log(data.response.result);
							if(self.$refs.loadmore){
								self.$refs.loadmore.onBottomLoaded(); //上拉加载
							}
							//追加数据
							for(var i = 0; i < data.response.result.length; i++) {
								self.groupList.push(data.response.result[i]);
							}
							if (self.pageNum * self.pageSize >= data.pageInfo.total) {
								self.allLoaded = true; //停止触发
							}
//							if(data.pageInfo.pages <= self.pageNum) { //总页数  为0 不触发
//								self.allLoaded = true; //停止触发
//							}	
						} else {
							console.log('请求失败');
						}
					},
					error: function() {
						console.log('error');
					}

				});
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/views/groupbuy/grouplist.vue